<template>
  <div class="el-main">
    <div class="card" v-show="currentCardId == 'edu-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>학력 입력</h2>
          <p>"자동 입력"을 사용하면 입학·졸업연도를 자동으로 계산할 수 있습니다.</p>
          <el-checkbox v-model="formatData.notDisplayIjyo">「이상」을 표시하지 않음 </el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <div class="edu-history-action">
              <auto-educational-backgrounds v-on:create-educational-background="setEducationalBackgrounds"
                :year="basicData.birthYear" :month="basicData.birthMonth"
                :day="basicData.birthDay"></auto-educational-backgrounds>
              <div class="button-reset">
                <el-button v-if="formatData.educationalHistories && formatData.educationalHistories.length > 1"
                  @click="$modal.show('educational-reset')">리셋</el-button>
              </div>
              <modal name="educational-reset" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('educational-reset');" icon="el-icon-close" type="text"></el-button>
                </div>
                <div class="title">학력리셋</div>
                <span>입력한 학력을 모두 삭제합니다.괜찮으신가요?</span>

                <div class="text-left">
                  <el-button type="primary"
                    @click="$modal.hide('educational-reset'); resetEducationalBackgrounds()">리셋함</el-button>
                  <el-button @click="$modal.hide('educational-reset')">리셋안함</el-button>
                </div>
              </modal>

            </div>
          </div>
          <div class="edit-form-item" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
            <div class="item-name">졸업예정</div>
            <div class="item-body">
              <el-select v-model="formatData.gradeYear" placeholder="선택 해주세요">
                <el-option v-for="item in gradeYearOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addEducationalHistory"
                v-on:delete-history-item="deleteEducationalHistory" v-on:move-history-item="moveEducationalHistory"
                v-for="(item, index) in formatData.educationalHistories" @click.native="activateHistoryItem(item.uuid)"
                :item="item" :length="formatData.educationalHistories.length" :index="index" :key="item.uuid"
                :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }" :minYear="basicData.birthYear"
                :ref="'EducationalHistory_' + index" :createDate="formatData.createDate"
                :descriptionPlaceholder="'학력 입력'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addEducationalHistory()"></el-button>
            </div>
          </div>
          <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
            <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'job-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>경력 입력</h2>
          <p>'자동 입력'을 사용하면 입사 및 퇴사 표기를 자동으로 작성할 수 있습니다.</p>
          <el-checkbox v-model="formatData.notDisplayIjyo">「이상」을 표시하지 않음 </el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="edit-form-list">
            <div class="add-item">
              <auto-job-histories v-on:job-histories-created="setJobHistories" :birth-year="basicData.birthYear"
                :birth-month="basicData.birthMonth" :birth-day="basicData.birthDay"></auto-job-histories>
              <div class="button-reset">
                <el-button type="" v-if="formatData.jobHistories && formatData.jobHistories.length > 1"
                  @click="$modal.show('job-reset')">리셋</el-button>
              </div>
              <modal name="job-reset" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('job-reset');" icon="el-icon-close" type="text"></el-button>
                </div>
                <div class="title">경력리셋</div>
                <span>현재 입력한 경력을 모두 삭제합니다.괜찮으신가요?</span>
                <div>
                  <el-button type="primary" @click="$modal.hide('job-reset'); resetJobHistories()">리셋함</el-button>
                  <el-button @click="$modal.hide('job-reset')">리셋안함</el-button>
                </div>
              </modal>
            </div>
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addJobHistory" v-on:delete-history-item="deleteJobHistory"
                v-on:move-history-item="moveJobHistory" v-for="(item, index) in formatData.jobHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.jobHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'JobHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="'경력 입력'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addJobHistory()"></el-button>
            </div>
            <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
              <i class="el-icon-warning"></i>&ensp;{{ previewErrors.eduJobHistory }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'license-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>면허・자격증 입력</h2>
          <p>면허・자격증은 예문에서 선택 할 수 있습니다.</p>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <el-button @click="$modal.show('license-dialog');" type="success">예문에서추가</el-button>
            <modal name="license-dialog" :adaptive="true" :scrollable="true" height="auto">
              <div class="v--modal-close-top">
                <el-button @click="$modal.hide('license-dialog');" icon="el-icon-close" type="text"></el-button>
              </div>
              <div class="title">예문선택</div>
              <div class="description">
                <p>선택한예문이 추가됩니다.</p>
              </div>
              <ul class="example-sentence">
                <li v-for="(item, index) in exampleSentences.license"
                  v-on:click="addLicenseHistory(null, { description: item }); $modal.hide('license-dialog');" :key="index">
                  <div class="title">{{ index }}</div>
                  <div class="body" v-html="item"></div>
                </li>
              </ul>
              <div class="text-right">
                <el-button @click="$modal.hide('license-dialog');">닫기</el-button>
              </div>
            </modal>
          </div>
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addLicenseHistory" v-on:delete-history-item="deleteLicenseHistory"
                v-on:move-history-item="moveLicenseHistory" v-for="(item, index) in formatData.licenseHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.licenseHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'LicenseHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="'면허・자격증 입력'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addLicenseHistory()"></el-button>
            </div>
            <div class="attention-limit column" v-if="previewErrors.licenseHistory">
              <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'reason'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>지원동기 입력</h2>
          <p>{{ reasonLabel }}</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('reason-dialog')" type="success">예문에서추가</el-button>
        </div>

        <div class="card-content">
          <modal name="reason-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('reason-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">예문선택</div>
            <div class="description">
              <p>선택한예문이 추가됩니다.</p>
              <p class="attention">예문을 선택하면 현재 입력 중인 문장은 덮어쓰게 되므로 주의하시기 바랍니다.</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.reason"
                v-on:click="formatData.reason = item.replace(/<br>/ig, '\n'); $modal.hide('reason-dialog')" :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('reason-dialog')">닫기</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.reason"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.reason">
            <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'reasonNew'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>자기PR 입력</h2>
          <p>{{ reasonLabel }}</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('reason-dialog')" type="success">예문에서추가</el-button>
        </div>

        <div class="card-content">
          <modal name="reason-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('reason-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">예문선택</div>
            <div class="description">
              <p>선택한예문이 추가됩니다.</p>
              <p class="attention">예문을 선택하면 현재 입력 중인 문장은 덮어쓰게 되므로 주의하시기 바랍니다.</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.reason"
                v-on:click="formatData.reasonNew += item.replace(/<br>/ig, '\n') + '\n'; $modal.hide('reason-dialog')"
                :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('reason-dialog')">닫기</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.reasonNew"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.reasonNew">
            <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'others'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>통근 시간 외</h2>
          <p>출퇴근 시간이나 부양가족 등을 입력합니다.</p>
        </div>
        <div class="card-content">
          <div class="edit-form">
            <div class="edit-form-item" v-if="optionItems.commuteDescription & this.formatId != 'rirekisho_job_new'">
              <div class="item-name">통근 수단<small>（전철, 버스, 자가용 등）</small></div>
              <div class="item-body">
                <el-input class="input-md" type="textarea" placeholder="전철" v-model="formatData.commuteDescription"
                  :autosize="{ minRows: 1, maxRows: 2 }">
                </el-input>
                <!--{{ $formLib.charCount(formatData.commuteDescription) }}-->
                <div class="error attention-limit character"
                  v-if="$formLib.charCount(formatData.commuteDescription) > 84">
                  <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.
                </div>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">통근시간</div>
              <div class="item-body">
                <el-input class="input-xs" placeholder="" title="시간" type="number"
                  v-model="formatData.commuteHours"></el-input> 시간
                <el-input class="input-xs" type="number" placeholder="" title="분"
                  v-model="formatData.commuteMinutes"></el-input> 분
              </div>

              <div class="item-name">부양가족(배우자 제외)</div>
              <div class="item-body">
                <el-input class="input-xs" placeholder="" title=부양가족수 type="number"
                  v-model="formatData.spouseNumber"></el-input> 명
              </div>
              <div class="item-name">배우자</div>
              <div class="item-body">
                <el-radio v-model="formatData.hasSpouse" :label="true"> 있음</el-radio>
                <el-radio v-model="formatData.hasSpouse" :label="false"> 없음</el-radio>
              </div>
              <div class="item-name">배우자의 부양의무</div>
              <div class="item-body">
                <el-radio v-model="formatData.underDutyToSupport" :label="true">있음</el-radio>
                <el-radio v-model="formatData.underDutyToSupport" :label="false">없음</el-radio>
              </div>
              <br>
              <div class="item-name" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
                유학생입니까?</div>
              <div class="item-body" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
                <el-radio v-model="formatData.foreignStudent" :label="true">네</el-radio>
                <el-radio v-model="formatData.foreignStudent" :label="false">아니오</el-radio>
              </div>
              <el-checkbox v-model="formatData.notDisplayRecommend">소개·추천을 표시하지 않음</el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'requests'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>본인 희망란 입력</h2>
          <p>급여, 직종, 근무시간, 근무지 등의 원하시는 내용을 입력할 수 있습니다(임의)</p>
        </div>
        <div class="add-item">
          <el-button @click="$modal.show('request-dialog')" type="success">예문에서추가</el-button>
        </div>
        <div class="card-content">
          <div class="edit-form-item">
            <div class="item-name">현재연봉</div>
            <div class="item-body">
              <el-input class="input-xs" placeholder="" title="현재연봉" type="number"
                v-model="formatData.nowNensyu"></el-input> 만원
            </div>
            <div class="item-name">희망연봉</div>
            <div class="item-body">
              <el-input class="input-xs" placeholder="" title="희망연봉" type="number"
                v-model="formatData.kibouNensyu"></el-input> 만원
            </div>
            <div class="item-name">※위 항목을 입력한 후 예문에서 추가 버튼을 클릭하여 예문을 선택하면 자동으로 반영됩니다.</div>
          </div>
          <br>
          <modal name="request-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('request-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">예문선택</div>
            <div class="description">
              <p>선택한예문이 추가됩니다.</p>
              <p class="attention">예문을 선택하면 현재 입력한 문장은 덮어쓰게 되므로 주의하시기 바랍니다.</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.request"
                v-on:click="formatData.request += item.replace(/<br>/ig, '\n').replace('OOO', formatData.nowNensyu).replace('XXX', formatData.kibouNensyu) + '\n'; $modal.hide('request-dialog');"
                :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('request-dialog');">닫기</el-button>
            </div>
          </modal>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 15 }" placeholder="급여, 직종, 근무시간, 근무지 등 희망사항이 있으면 입력"
            v-model="formatData.request">
          </el-input>
          <div class="attention-limit character" v-if="previewErrors.request">
            <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>이력서 작성일 입력</h2>
          <p>작성일을 선택해 주세요.</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                  @click="formatData.createDate = $formLib.getToday()">오늘로 선택</el-button>
              </div>
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                  @click="formatData.createDate = $formLib.getTommorow()">내일로 선택</el-button>
              </div>
              <div class="action-item">
                <el-date-picker v-model="formatData.createDate" type="date" :clearable="false" placeholder="선택 해주세요"
                  :format="'yyyy년M월d일'" ref="create_date">
                </el-date-picker>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header" style="max-width: 40rem;margin: 2rem auto -3rem;">
          <h2>작성한 내용 확인</h2>
        </div>
      </div>
    </div>


    <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">

      <download-item :formatId="formatId" :isSendYagiPostEnabled="isSendYagiPostEnabled"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled" :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled" :downloadActiveCollapses="downloadActiveCollapses"></download-item>



      <div class="overflow-scroll-y" v-if="false">
        <div class="card-header">
          <h2>ダウンロード</h2>
          <p v-if="false">作成した履歴書をPDFでダウンロードします。<br>メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。</p>
          <p style="color:red;" v-if="!$firebase.isAuthenticated">
            ※ヤギの宅配便、メール送信、コンビニ印刷、ダウンロードはログインが必須となります。<br>下記のログインフォームでログインしてください。</p>
        </div>
        <div class="card-content">
          <div class="button-download-pdf" v-if="$firebase.isAuthenticated">
            <div class="bnr_container" v-if="formatId == 'internship'" style="padding: 0;">
              <div class="bnr_item">
                <img @click="$eventHub.$emit('send-yagish-intern');"
                  src="/kr/resume/static/renew_img/bnr/intern_yagish_bnr_20230414.png" alt="Yagishインターン">
                <div class="bnr_txt" v-if="!isSendedYagishIntern">
                  <ul style="font-size: 0.8rem; margin-left: 0;text-align: left;">
                    <li>※応募するバナーをクリックすると、作成した履歴書がYagishに送付されます。</li>
                    <li>※選考に進む際はこちらからご連絡いたします。</li>
                    <li>※インターンに関する採用情報は<a href="https://www.yagish.jp/recruit-info/intern2023/"
                        target="_blank">こちら</a>からご確認ください。</li>
                  </ul>
                </div>
                <div class="bnr_txt" v-else>
                  <ul style="font-size: 0.8rem; margin-left: 0;">
                    <li>履歴書が送付されました。ありがとございます</li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="completed-buttons" class="bnr_container" v-if="isWeekEndFlag">
              <div id="quickmail" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      <p>履歴書送付は任せろメェ〜</p>
                      <br>
                      <h3>ヤギの宅配便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                  <img src="/kr/resume/static/renew_img/mailbuy_sale20230602.png" alt="ヤギの宅配便"
                    style="border-radius: 0 0 10px 10px;">
                </div>
              </div>

              <div id="quickemail" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                      @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                      <p>応募先企業に1クリックで送信</p>
                      <br>
                      <h3>ヤギのメール便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                  <img src="/kr/resume/static/renew_img/quickemail_button.png" alt="ヤギのメール便"
                    style="border-radius: 0 0 10px 10px;">
                </div>
              </div>

              <div id="combie" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt" style="border-radius: 10px 10px 0 0;">
                    <el-button id="pdf-eprint-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      @click="$eventHub.$emit('show-preview-4conv')">
                      <p>면접에 이력서가 필요해?인쇄해! 메에~</p>
                      <br>
                      <h3>コンビニプリント<span>をつかう</span></h3>
                    </el-button>
                  </div>
                  <img src="/kr/resume/static/renew_img/print.png" alt="コンビニプリント" style="border-radius: 0 0 10px 10px;">
                </div>
              </div>

              <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                      <p>登録したメアドに送るメェ〜</p>
                      <br>
                      <h3>PDFをメールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※로그인 해주세요.</p>
                </div>
              </div>
              <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('send-email-verification');">
                      <p>PDFファイルを</p>
                      <p>登録したメアドに送るためには</p>
                      <br>
                      <h3>確認メールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※로그인 해주세요.</p>
                </div>
              </div>

              <div id="pdf-download" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                      @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                      <p>端末に保存するメェ〜</p>
                      <br>
                      <h3>PDFをダウンロードする</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note">
                    <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                      rel="nofollow">※できない場合はこちら</a>
                  </p>
                </div>
              </div>

            </div>

            <div id="completed-buttons" class="bnr_container" v-else>
              <div id="quickmail" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <img src="/kr/resume/static/renew_img/mailbuy_sale20230602.png" alt="ヤギの宅配便">
                  <div class="bnr_txt">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="$eventHub.$emit('send-special-post', formatId); isSendYagiPostEnabled = false">
                      <p>履歴書送付は任せろメェ〜</p>
                      <br>
                      <h3>ヤギの宅配便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>

              <div id="quickemail" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <img src="/kr/resume/static/renew_img/quickemail_button.png" alt="ヤギのメール便">
                  <div class="bnr_txt">
                    <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !isSendYagiEmailEnabled"
                      @click="$eventHub.$emit('send-special-quickemail', formatId); isSendYagiEmailEnabled = false">
                      <p>応募先企業に1クリックで送信</p>
                      <br>
                      <h3>ヤギのメール便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>

              <div id="combie" class="bnr_itemWrapper">
                <div class="bnr_item">
                  <img src="/kr/resume/static/renew_img/print.png" alt="コンビニプリント">
                  <div class="bnr_txt">
                    <el-button id="pdf-eprint-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      @click="$eventHub.$emit('show-preview-4conv')">
                      <p>면접에 이력서가 필요해?인쇄해! 메에~</p>
                      <br>
                      <h3>コンビニプリント<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>

              <div id="pdf-email" class="bnr_itemWrapper" v-if="$firebase.user.emailVerified">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !mailPdfEnabled"
                      @click="$eventHub.$emit('mail-PDF'); mailPdfEnabled = false">
                      <p>登録したメアドに送るメェ〜</p>
                      <br>
                      <h3>PDFをメールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※로그인 해주세요.</p>
                </div>
              </div>
              <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline" @click="$eventHub.$emit('send-email-verification');">
                      <p>PDFファイルを</p>
                      <p>登録したメアドに送るためには</p>
                      <br>
                      <h3>確認メールで送る</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note" v-if="!$firebase.isAuthenticated">※로그인 해주세요.</p>
                </div>
              </div>

              <div id="pdf-download" class="bnr_itemWrapper" v-if="$site.appFlag != 'b'">
                <div class="bnr_item">
                  <div class="bnr_txt txt">
                    <el-button id="pdf-mail-edit" style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                      :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
                      @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false;">
                      <p>端末に保存するメェ〜</p>
                      <br>
                      <h3>PDFをダウンロードする</h3>
                    </el-button>
                  </div>
                  <p class="bnr_note">
                    <a href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget" target="_blank"
                      rel="nofollow">※できない場合はこちら</a>
                  </p>
                </div>
              </div>

            </div>

          </div>
          <div class="button-download-pdf" v-else>
            <div class="text-center">
              <login-forms />
            </div>
          </div>
        </div>
        <div class="card-content">
          <el-collapse v-model="downloadActiveCollapses">

            <el-collapse-item title="ヤギにはがきを渡す" v-if="false" name="postcard">
              <div><router-link id="footer-link-postcard" :to="{ name: 'postCard' }"><img
                    src="/kr/resume/static/img/postcard/postyagi.svg"
                    alt="郵便ヤギ"><br>ヤギや運営へのひとことメッセージをお待ちしています</router-link></div>
            </el-collapse-item>

            <el-collapse-item title="スマホから履歴書を印刷するには" name="print">
              <div>GoogleドライブやDropboxなどのクラウドストレージを使用するか、Gmail経由で自分宛てにPDFを送ってデータを保存します。印刷は自宅のプリンタまたはコンビニ印刷などをご利用下さい。
              </div>
              <div v-if="!$firebase.isAuthenticated">コンビニ印刷のサービスご利用には、ログイン(無料)が必要になります。</div>
              <ul class="collapse-list" v-if="$firebase.isAuthenticated">
                <li>
                  <a id="pdf-eprint-edit" type="success" style="cursor:pointer;" :disabled="!$deviceLib.isOnline"
                    @click="$eventHub.$emit('show-preview-4conv')">
                    セブンイレブン・ファミリーマート・ローソンなど - eプリント
                  </a>
                </li>
              </ul>
            </el-collapse-item>
            <el-collapse-item title="他の端末から続きを書くには" name="backup">
              <div>
                他の端末から続きを編集したい場合は、Googleアカウントでログインし「バックアップをとる」でデータを保存して続きを書くことができます。なお、会員登録していない状態でも、現在入力されている端末からであれば続きの入力ができます（ブラウザのデータを削除したり、端末を変更した場合はリセットされます）。
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>


  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #EFF8F8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}






* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>

<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import DownloadItem from './CommonParts/DownloadItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'RirekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'download-item': DownloadItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      saveName: 'rirekisho',
      saveOtherName: 'shokumukeirekisho',
      activeName: '1',
      formatData: {
        createDate: null,
        educationalHistories: [],
        jobHistories: [],
        licenseHistories: [],
        commuteDescription: '',
        commuteHours: '',
        commuteMinutes: '',
        spouseNumber: '',
        hasSpouse: false,
        underDutyToSupport: false,
        reason: '',
        reasonNew: '',
        request: '',
        nowNensyu: '',
        kibouNensyu: ''
      },
      isWeekEndFlag: true,
      activeHistoryItem: '',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      previewScale: 1,
      previewViewerCss: {},
      isNew: false,
      textareaMinRows: 3,
      reasonLabel: '지원동기, 특기, 좋아하는학과, 어필포인트 등, 쓰기가 막막할때에는 예문을 바탕으로 작성할 수 있습니다.',
      downloadActiveCollapses: ['postcard'],
      gradeYearOptions: [
        {
          value: '23',
          label: '23년졸'
        },
        {
          value: '24',
          label: '24년졸'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagish고딕'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish명조'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: '도트고딕16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagish고딕'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish명조'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: '도트고딕16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    setEducationalBackgrounds: function (historyList) {
      this.formatData.educationalHistories = []
      // 常に先頭から追加
      let index = 0
      for (let key in historyList) {
        let item = historyList[key]
        this.addEducationalHistory(index++, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    addExampleSentences: function (selectedSentences, modal) {
      let tArea = this.$refs.yourTextarea
      let startPos = tArea.selectionStart
      let endPos = tArea.selectionEnd
      let tmpStr = tArea.value
      console.error(tArea)
      console.error(startPos)
      this.formatData.reasonNew = tmpStr.substring(0, startPos) + selectedSentences + tmpStr.substring(endPos, tmpStr.length)
      modal.hide('reason-dialog')
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (let key in historyList) {
        let item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetEducationalBackgrounds: function () {
      this.formatData.educationalHistories = []
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new HistoryData(columns.year, columns.month, columns.description)
    },
    addHistory: function (historyList, index, refId, columns) {
      const newHistoryItem = this.createHistoryItem(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    addEducationalHistory: function (index, columns) {
      console.error(this.formatData)
      this.addHistory(this.formatData.educationalHistories, index, 'EducationalHistory_', columns)
    },
    moveEducationalHistory: function (params) {
      this.moveHistory(this.formatData.educationalHistories, params)
    },
    addJobHistory: function (index, columns) {
      this.addHistory(this.formatData.jobHistories, index, 'JobHistory_', columns)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    addLicenseHistory: function (index, columns) {
      this.addHistory(this.formatData.licenseHistories, index, 'LicenseHistory_', columns)
    },
    moveLicenseHistory: function (params) {
      this.moveHistory(this.formatData.licenseHistories, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteEducationalHistory: function (index) {
      this.formatData.educationalHistories.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteLicenseHistory: function (index) {
      this.formatData.licenseHistories.splice(index, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    }
  },
  watch: {
    'formatData.createDate': function (newValue, oldValue) {
      this.formatData.writeDate = this.$formLib.dateFormat(newValue, 'yyyy년 m월 d일')
    }
  },
  created: function () {

    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode != 'production') {
      this.isWeekEndFlag = true
    }

  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    if (this.formatId === 'rirekisho_job_new') {
      this.textareaMinRows = 10
      this.reasonLabel = '지원동기, 특기, 좋아하는학과, 어필포인트 등, 쓰기가 막막할때에는 예문을 바탕으로 작성할 수 있습니다.'
    }
    if (this.formatId === 'rirekisho_job_new_single') {
      this.textareaMinRows = 6
      this.reasonLabel = '지원동기, 특기, 좋아하는학과, 어필포인트 등, 쓰기가 막막할때에는 예문을 바탕으로 작성할 수 있습니다.'
    }
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
  }
}
</script>
